import { ICultureResources } from '../../models/resource.model';

export const jaJP: ICultureResources = {
    cssVars: {
        fontFamilyTitle: 'Noto Sans JP Variable',
        fontFamilyText: 'Noto Sans JP Variable',
    },
    preloads: [
        {
            tag: 'link',
            location: 'head',
            attributes: {
                href: '/assets/fonts/noto-sans-jp/files/noto-sans-jp-latin-wght-normal.woff2',
                rel: 'preload',
                as: 'font',
                type: 'font/woff2',
                crossorigin: 'anonymous',
            },
        },
    ],
    styles: [
        {
            tag: 'link',
            location: 'head',
            persist: true,
            attributes: {
                href: '/assets/fonts/noto-sans-jp/index.css',
                rel: 'stylesheet',
            },
        },
    ],
};
